import {
  MoreVerticalOutlineIcon,
  RevertOutlineIcon,
  ShowOutlineIcon,
} from '@carboncopyco/icons';
import { Button, Dropdown, DropdownItem } from '@carboncopyco/ui';
import { type ReactNode, isValidElement } from 'react';

interface ArchiveTileDropdownProps {
  preview?: () => void;
  restore: () => void;
  open: boolean;
  inFolder?: boolean;
  toggleOpen: () => void;
  triggerElement?: ReactNode;
}

export const ArchiveTileDropdown = ({
  preview,
  restore,
  open,
  inFolder,
  toggleOpen,
  triggerElement,
}: ArchiveTileDropdownProps) => {
  return (
    <Dropdown
      side="right"
      open={open}
      onOpenChange={toggleOpen}
      asChild
      triggerElement={
        isValidElement(triggerElement) ? (
          triggerElement
        ) : (
          <Button
            aria-label="archive tile actions"
            small
            dark
            icon={<MoreVerticalOutlineIcon />}
          />
        )
      }
    >
      <div className="flex flex-col p-1 gap-2">
        {preview && (
          <DropdownItem
            iconLeft={<ShowOutlineIcon size={20} />}
            label="Preview"
            onClick={(event) => {
              event.preventDefault();
              preview();
            }}
          />
        )}
        {!inFolder && (
          <DropdownItem
            iconLeft={<RevertOutlineIcon size={20} />}
            label="Restore"
            onClick={restore}
          />
        )}
      </div>
    </Dropdown>
  );
};
